var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInboxChatbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12 3c1.293 0 2.34 1.021 2.34 2.28 0 1.044-.72 1.924-1.702 2.195v.5h4.894c1.292 0 2.34 1.022 2.34 2.281v.694C21.093 11.231 22 12.3 22 13.573c0 1.274-.907 2.342-2.127 2.623v1.524c0 1.259-1.049 2.28-2.341 2.28H6.468c-1.292 0-2.34-1.021-2.34-2.28v-1.524C2.907 15.915 2 14.847 2 13.573c0-1.274.907-2.342 2.127-2.623v-.694c0-1.26 1.049-2.28 2.341-2.28l4.893-.001v-.5c-.982-.27-1.701-1.15-1.701-2.195C9.66 4.021 10.707 3 12 3zm5.532 6.22H6.468c-.587 0-1.064.464-1.064 1.036v7.464c0 .572.477 1.036 1.064 1.036h11.064c.587 0 1.064-.464 1.064-1.036v-7.464c0-.572-.477-1.036-1.064-1.036zm-3.66 5.827a.62.62 0 0 1 .445.765c-.301 1.061-1.126 1.63-2.317 1.63-1.19 0-2.016-.569-2.317-1.63a.62.62 0 0 1 .444-.765.64.64 0 0 1 .786.433c.143.505.453.718 1.087.718.634 0 .944-.213 1.087-.718a.64.64 0 0 1 .786-.433zm-9.745-2.785a1.45 1.45 0 0 0-.85 1.311c0 .579.347 1.078.85 1.311v-2.622zm15.746 0v2.622a1.45 1.45 0 0 0 .85-1.31 1.45 1.45 0 0 0-.85-1.312zM8.596 10.878a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7zm6.808 0a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7zM12 4.244c-.588 0-1.064.464-1.064 1.036A1.05 1.05 0 0 0 12 6.317a1.05 1.05 0 0 0 1.064-1.037c0-.572-.476-1.036-1.064-1.036z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxChatbot);
export default __webpack_public_path__ + "static/media/ic-inbox-chatbot.2d72a1760a691d5c357d89231315240d.svg";
export { ForwardRef as ReactComponent };